import { global } from './global';

import '@fontsource/poppins/500.css';

export const styles = {
    global: () => global()
};
